import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: auto;
  position: relative;
  overscroll-behavior-x: none;
`

export const ContentWrapper = styled.div`
  width: min-content;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`

export const StickyContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: white;
`
